module.exports = __webpack_public_path__ + "img/hyh@2x.7fe4431a.png";